<div class="aplayer-music">
  <span class="aplayer-title">{{ title || '没有加载音频' }}</span>
  <span class="aplayer-author"> - {{ author || '(ಗ ‸ ಗ )' }}</span>
</div>



// WEBPACK FOOTER //
// ./src/components/Info/src/Info.html